import * as types from './entryQualificationSubject.types'

export const actions = {
	toggleLoading: payload => ({
		type: types.TOGGLE_LOADING,
		payload,
	}),
	toggleSuccess: payload => ({
		type: types.TOGGLE_SUCCESS,
		payload,
	}),
	set: payload => ({
		type: types.SET_ENTRY_QUALIFICATION_SUBJECT,
		payload,
	}),
	create: payload => ({
		type: types.CREATE_ENTRY_QUALIFICATION_SUBJECT,
		payload,
	}),
	get: payload => ({
		type: types.GET_ENTRY_QUALIFICATION_SUBJECT,
		payload,
	}),
	edit: payload => ({
		type: types.EDIT_ENTRY_QUALIFICATION_SUBJECT,
		payload,
	}),
	delete: payload => ({
		type: types.DELETE_ENTRY_QUALIFICATION_SUBJECT,
		payload,
	}),
	getOptions: () => ({
		type: types.GET_OPTIONS,
	}),
	setOptions: payload => ({
		type: types.SET_OPTIONS,
		payload,
	}),
	clearData: () => ({
		type: types.CLEAR_DATA,
	}),
	setPermissions: payload => ({
		type: types.SET_PERMISSIONS,
		payload,
	}),
}
